import { TranslationsService } from '@inter-ikea-kompis/services';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getLocale } from 'i18n/i18nUtils';
import { IThunkApi } from 'redux-store/store';
import { translationEndpoints } from 'utils/constants/serviceSettings';
import ISkyttaTranslations from './ISkyttaTranslations';

let service: TranslationsService<ISkyttaTranslations>;

const getService = () => {
  if (!service) {
    service = new TranslationsService<ISkyttaTranslations>({
      locale: getLocale(),
      translationEndpoints
    });
  }

  return service;
};

export const fetchTranslations = createAsyncThunk<ISkyttaTranslations | null, undefined, IThunkApi>(
  'translations/fetchTranslationsStatus',
  async () => {
    return getService().getTranslations();
  }
);
